import rootSagas from 'mk2/apps/forum/sagas';
import Application from 'mk2/containers/Application/Application';
import { appInit } from 'mk2/helpers/init';
import { routes } from 'mk2/router';

appInit(
    Application,
    routes,
    rootSagas,
).then((rerender) => {
    if (module.hot) {
        module.hot.accept(['mk2/containers/Application/Application', 'mk2/router'], () => {
            const NextApp = require('mk2/containers/Application/Application').default;
            rerender(NextApp);
        });
    }
});
